<template>
	<div>
		<h3 class="heading">Technical Details</h3>
		<table class="technical-details">
			<thead>
				<tr>
					<th>Property</th>
					<th>Value</th>
				</tr>
			</thead>
			<tbody>
				<tr :class="detail.type" v-for="(detail, index) in technicalDetails" :key="index">
					<td :class="detail.type" class="property">{{ detail.property }}</td>
					<td :class="detail.type" class="value">{{ detail.value }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>


<script>
	import FinishGroup from './FinishGroup.vue';

	export default {
		props: ['technicalDetailsProp'],
		data() {
			return {};
		},
		computed: {
			technicalDetails: function() {
				return this.technicalDetailsProp.filter(detail => detail.value != '0 Watts / 0 Btu' && detail.value != '0 Watts');
			},
		},
	};
</script>

<style scoped>
	.heading {
		font-size: 16px;
		line-height: 1.2;
		margin: 10px 0;
	}

	.technical-details {
		width: 100%;
		font-size: 14px;
		color: #333;
		border-collapse: collapse;
	}

	thead {
		background: #eee;
	}

	th,
	td {
		padding: 9px 18px;
		text-align: left;
	}

	tr {
		border-top: 1px solid #eee;
	}

	tr.sub {
		border-top: none;
	}

	tr.sub td {
		padding: 1px 18px;
	}

	tr.sub td.property {
		padding: 1px 18px 1px 28px;
	}

	tr.sub.last td {
		padding-bottom: 9px;
	}

	tr:last-of-type {
		border-bottom: 1px solid #eee;
	}
</style>